// frontend/admin-portal/src/components/orders/OrderStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner, formatMoney } from "@fiberhome/shared-ui";
import { orderService } from "../../services/orderService";
import { useSettings } from "../../contexts/SettingsContext";

export default function OrderStats({ refreshKey = 0 }) {
  const { get } = useSettings();
  const currency = get("finance.currencySymbol", "$");
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    orderService
      .stats()
      .then((s) => alive && setStats(s))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const cards = [
    { label: "Offers", value: stats?.offers ?? "—" },
    { label: "Orders", value: stats?.orders ?? "—" },
    {
      label: "Accepted",
      value: stats?.accepted ?? "—",
      color: "var(--fh-success)",
    },
    {
      label: "Revenue",
      value: stats ? formatMoney(stats.revenue, { symbol: currency }) : "—",
      color: "var(--fh-primary)",
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title
              level={3}
              className="mb-0"
              style={{ color: c.color, fontSize: 20 }}
            >
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
